import React from "react";
import { View, Text, Pressable, Linking, StyleSheet } from "react-native";
import { fontFamily } from "../../constants/fonts";
import {
  PALOMA_NAVY,
  PALOMA_ACCENT,
  PALOMA_SHEET_TITLE_LINE1,
  PALOMA_SHEET_TITLE_LINE2,
  PALOMA_SHEET_DESCRIPTION,
  PALOMA_PARTIFUL_URL,
  PALOMA_PARTIFUL_LINK_LABEL,
} from "../../constants/palomaPaloozaBrand";

/** Shared title, promo copy, and Partiful link for Paloma Palooza sheets (web + mobile). */
export default function PalomaPaloozaSheetHeader({
  titleFontSize = 24,
  subtitleFontSize = 18,
  style,
}) {
  return (
    <View style={[styles.container, style]}>
      <Text style={[styles.title, { fontSize: titleFontSize }]}>{PALOMA_SHEET_TITLE_LINE1}</Text>
      <Text style={[styles.subtitle, { fontSize: subtitleFontSize, marginTop: 4 }]}>
        {PALOMA_SHEET_TITLE_LINE2}
      </Text>
      <Text style={styles.description}>{PALOMA_SHEET_DESCRIPTION}</Text>
      <Pressable
        onPress={() => Linking.openURL(PALOMA_PARTIFUL_URL)}
        accessibilityRole="link"
        accessibilityLabel={PALOMA_PARTIFUL_LINK_LABEL}
        style={({ pressed }) => [styles.linkPressable, pressed && styles.linkPressed]}
      >
        <Text style={styles.link}>{PALOMA_PARTIFUL_LINK_LABEL}</Text>
      </Pressable>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    alignItems: "center",
    paddingHorizontal: 12,
  },
  title: {
    fontFamily: fontFamily.abhayaBold,
    fontWeight: "700",
    color: PALOMA_NAVY,
    textAlign: "center",
  },
  subtitle: {
    fontFamily: fontFamily.abhayaBold,
    fontWeight: "700",
    color: PALOMA_NAVY,
    textAlign: "center",
  },
  description: {
    marginTop: 8,
    fontFamily: fontFamily.abhaya,
    fontSize: 15,
    lineHeight: 20,
    color: "#4B5563",
    textAlign: "center",
  },
  linkPressable: {
    marginTop: 6,
    paddingVertical: 2,
    paddingHorizontal: 4,
  },
  linkPressed: {
    opacity: 0.75,
  },
  link: {
    fontFamily: fontFamily.abhayaBold,
    fontSize: 15,
    color: PALOMA_ACCENT,
    textAlign: "center",
    textDecorationLine: "underline",
  },
});
